import { Column } from '@/components'
import styled from 'styled-components'

export const Container = styled(Column)`
  height: 100%;
  width: 100%;
`
